// extracted by mini-css-extract-plugin
export default {"wrapper":"SegmentVertical-module__wrapper___wTl09","removeWrapper":"SegmentVertical-module__removeWrapper___McQLk","remove":"SegmentVertical-module__remove___tEndq"};